<template>
  <footer v-if="!pathMixin_isMeeting && !pathMixin_isMeetingLandingPage" class="footer is-block p-5">
    <div class="content has-text-centered">
      <p class="is-size-7 has-text-grey">
        <span class="krungthep"><strong>TripCircuit</strong></span> wired for <a href="https://www.ganttravel.com/" target="_blank">Gant Travel Management</a>
        <span class="mx-2">
          <b-icon
                icon="airplane"
                size="is-small">
            </b-icon>
        </span>
        <span class="">App Version {{ $store.getters['app/appVersion'] }}</span>
        <span class="tag is-warning ml-2" v-if="this.$appConfig.appEnvironment !== 'production'">{{ this.$appConfig.appEnvironment }}</span>
        <a v-on:click.stop="$app.getCurrentAppVersion()" class="is-inline-block ml-1 has-text-grey-light">Check for updates</a>
      </p>
        <div v-if="!$store.getters['app/appVersionsMatch']" class="mt-3 has-text-grey is-size-7">
          A newer version of TripCircuit is available. <br><a v-on:click.stop="$app.refreshBrowser()" class="is-inline-block">Load the new version</a> (Note: You will be logged out during this process)
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
